export enum NodeStatus {
  Adding, // represents that the current node is being created, and an input displays on the page.
  Editing, // represents that the current node is being updated, and an input displays on the page with the node's name in it.
  Display // the node shows on the page as text
}
